import React, { FC, useEffect, useMemo } from 'react'
import SelectDropDown, { CustomDropdownPropTypes } from '../SelectDropDown/SelectDropDown'
import { useAppDispatch, useAppSelector } from '../globalExports'
import CustomDatePicker, { CustomDatePickerProps } from '../CustomDatePicker/CustomDatePicker'
import {getAcFilterReducer, getAcReferenceDataReducer,fetchAcAlarmSeverityReferenceData, fetchAcCustomerReferenceData, fetchAcChargerVisibleIdReferenceData, fetchAcChargerProductTypeReferenceData,fetchAcChargerStationReferenceData, fetchAcAlarmTypeReferenceData} from '../../acModules/rmsReduxStore/acReduxExports'
import { getAcFilterSelectedValue } from '../../acModules/rmsReduxStore/acFiltersRedux/acFiltersCreators'
import { fetchAlarmStatusReferenceData, fetchCertificateStatusReferenceData, fetchChargerStatusReferenceData, fetchUsersReferenceData } from '../../rmsReduxStore/reduxExports'
// import { cloneDeep } from 'lodash'

export interface FilterProp {
  filterId: string
  filterLabel: string
  filterType: 'dropdown' | 'dateFilter'
  filterDropdownProps?: CustomDropdownPropTypes | null,
  dateFilterProps?: CustomDatePickerProps | null
  width?: string
}

interface FilterLayoutProps {
  screen?:string
  filters: FilterProp[],
  excludeGlobalFilters?: boolean,
  requiredReferenceDataCallbacks: ('customer' | 'severity' | 'chargerModel' | 'location' | 'status' | 'chargerType' | 'region' | 'softwareVersion' | 'chargingStation' | 'alarmType' | 'chargerVisibleId' | 'parameterName' | 'user' | 'editHistory' | 'orgName' | 'visibility' | 'chargingStationId'|'productType'|'alarmTypeId'|'typeOfNotification'| 'stopReasonCode' | 'ruleId' | 'alarmSeverity' |'activeCertificate' |'userRemoteCommand' | 'chargerCertificateStatus')[] | string[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleFilterDataChange?:Function;
}

export const referenceDataCallBackMapper = [
  {
    key: 'customer',
    referenceDataCallBack: fetchAcCustomerReferenceData
  },
  {
    key: 'severity',
    referenceDataCallBack: fetchAcAlarmSeverityReferenceData
  },
  {
    key:'alarmState',
    referenceDataCallBack: fetchAlarmStatusReferenceData
  },
  {
    key: 'status',
    referenceDataCallBack: fetchChargerStatusReferenceData
  },
  {
    key: 'alarmType',
    referenceDataCallBack: fetchAcAlarmTypeReferenceData
  },
  {
    key: 'chargerVisibleId',
    referenceDataCallBack: fetchAcChargerVisibleIdReferenceData
  },
  {
    key: 'productType',
    referenceDataCallBack: fetchAcChargerProductTypeReferenceData
  },
  {
    key: 'chargingStationId',
    referenceDataCallBack: fetchAcChargerStationReferenceData
  },
  {
    key: 'chargerCertificateStatus',
    referenceDataCallBack: fetchCertificateStatusReferenceData
  },
  {
    key: 'user',
    referenceDataCallBack: fetchUsersReferenceData
  }
]

const AcFilterLayout: FC<FilterLayoutProps> = (props) => {
  const {screen, filters, requiredReferenceDataCallbacks,handleFilterDataChange, excludeGlobalFilters } = props;
  const dispatch = useAppDispatch()
  const {acCustomerReferenceData } = useAppSelector(getAcReferenceDataReducer);
  const {globalFilters} = useAppSelector(getAcFilterReducer)

  useEffect(() => {
    if (requiredReferenceDataCallbacks && requiredReferenceDataCallbacks?.length > 0) {
      // Adding Global filters callBacks key to coming callBacks keys props...
      const referenceDataCallBacks = requiredReferenceDataCallbacks.concat(['customer'])
      referenceDataCallBacks?.forEach(type => {
        const callbackItem = referenceDataCallBackMapper?.find(item => item?.key === type);
        if (callbackItem) {
          if ((screen === 'charging_history' || screen === 'alarms') && type === 'chargerVisibleId') {
            const selectedCustomerFilter = getAcFilterSelectedValue('customer','global',true)
            const reqBody = {
              customerIds : selectedCustomerFilter?.filter((item) => item?.id === 'all')?.length > 0  ? ['all'] : selectedCustomerFilter?.map((customer) => customer?.id)
            }
            dispatch(callbackItem?.referenceDataCallBack(reqBody))
          } else {
            dispatch(callbackItem?.referenceDataCallBack())
          }
        }
      })
    } else {
      dispatch(fetchAcCustomerReferenceData())
    }
  }, [])


  const globalFiltersProps: FilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: screen === 'newDashboard' ? 'Customer' : 'Customers',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: getAcFilterSelectedValue('customer','global',true),
          selectOptions: acCustomerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange?.(val, 'customer',true)
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true
        }
      },
    ]
    
  }, [ acCustomerReferenceData,globalFilters])



  const allFilters = excludeGlobalFilters? [...filters] : [...globalFiltersProps,...filters]

  return (
    allFilters && allFilters?.length > 0 && allFilters?.map((filter, index) => {
      return (
        <div key={index} className="side__filter__wrap-content-row" style={{width: filter?.width}}>
          <div className="side__filter__wrap-content-row-label">{filter?.filterLabel}</div>
          <div className="side__filter__wrap-content_filter">
            {filter.filterType === 'dropdown' && filter?.filterDropdownProps &&
              <SelectDropDown
                selectValue={filter?.filterDropdownProps?.selectValue}
                selectOptions={filter?.filterDropdownProps?.selectOptions ?? []}
                handleSelectOptionChange={filter?.filterDropdownProps?.handleSelectOptionChange}
                selectDropDownId={filter?.filterDropdownProps?.selectDropDownId}
                isMultiSelect={filter?.filterDropdownProps?.isMultiSelect}
                renderToBody={filter?.filterDropdownProps?.renderToBody}
                menuPlacement={filter?.filterDropdownProps?.menuPlacement}
                // renderToBody={true}
              />
            }
            {filter.filterType === 'dateFilter' && filter?.dateFilterProps &&
              <CustomDatePicker startDate={filter?.dateFilterProps?.startDate ? new Date(filter?.dateFilterProps?.startDate) : null} endDate={filter?.dateFilterProps?.endDate ? new Date(filter?.dateFilterProps?.endDate) : null} selectsRange={filter?.dateFilterProps?.selectsRange} onChange={filter?.dateFilterProps?.onChange} includeDateIntervals={filter?.dateFilterProps.includeDateIntervals} />}
          </div>
        </div>
      )
    }
    ))
}

export default AcFilterLayout